module.exports = __webpack_public_path__ + "img/leaf-oak.d50e836e.svg";